import PropTypes from '../vue-types';

export var storeShape = PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/store/PropTypes.js
// module id = 527
// module chunks = 0